<template>
  <div class="userwrapper">
    <!-- <p class="main">蓝鲨电动用户服务协议</p> -->
    <p class="title">特别提示</p>
    <p>鲨湾科技（上海）有限公司（以下简称“鲨湾科技”）在此特别提醒您（用户）在注册成为用户之前，请认真阅读和理解本《用户服务协议》（以下简称“协议”），请您务必审慎阅读、充分理解本《协议》中的各项条款内容，并选择接受或不接受本《协议》。除非您阅读并接受本《协议》中所有条款，否则您无权注册、登录或使用本《协议》所涉及的相关服务。您一旦注册、登录或使用《协议》所涉及的相关服务，即视为对本《协议》的接受，表示您同意接受本《协议》各项条款的约束。如果您不同意本《协议》中的条款或对本协议中的任何条款存在疑问，请您不要注册、登录或使用本《协议》相关服务。</p>
    <p>本《协议》约定鲨湾科技与用户之间关于“蓝鲨电动”软件服务（以下简称“本服务”）的权利义务。“用户”是指注册、登录、使用本服务的个人。我们有权随时根据有关法律、法规的变化以及公司经营状况和经营策略的调整等修改本《协议》，更新后的协议条款一旦公布即代替原来的协议条款而无需另行单独通知用户。修改后的《协议》会在本服务内公布，用户可以在本软件、本服务的最新版本中查阅相关协议条款。本《协议》条款变更后，如果您继续使用本软件、本服务，即视为您已接受修改后的协议。如果您不接受修改后的《协议》，应当停止使用本软件。</p>
    <p>如果您未满18周岁，请在法定监护人的陪同下阅读本协议及其他上述协议，并特别注意未成年人使用条款。</p>
    <p class="title">一、服务内容</p>
    <p>1. 本服务的具体内容由蓝鲨电动所属公司或已得到相应权利人授权的内容，根据实际情况提供，包括但不限于授权用户通过其帐号查看车况，定位车辆，车辆动态记录，以及遥控车辆，设置车辆等功能（具体服务内容在蓝鲨电动内查看）。蓝鲨电动可以对其提供的服务予以变更，且蓝鲨电动提供的服务内容可能随时变更；用户将会收到蓝鲨电动关于服务变更的通知。</p>
    <p>2. 用户理解并接受，蓝鲨电动仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、以及其他与接入互联网或移动互联网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网络而支付的手机费）均由用户自行负担。</p>
    <p>3. 请您务必在确保安全的前提下使用蓝鲨电动，以防发生交通事故或其他危险情况。蓝鲨电动仅供参考，在您出行或行驶时以实际的交通路况为准，严格遵守相关法律法规和交通规则。</p>
    <p>4. 蓝鲨电动服务需要结合相关设备使用，您保证您为所使用设备的合法所有者或使用者，否则您应当立即停止使用相关产品并将设备归还给设备所有人。如果您对您使用的设备进行任何形式的拆卸、改装等可能影响设备性能的操作，可能会导致蓝鲨电动的部分或全部服务无法使用，您理解并自行承担此风险，鲨湾科技对此不承担任何责任。如果您将您使用的设备赠与、转让、售卖、借用或租用给他人，您应当充分告知蓝鲨电动服务的存在及本用户服务条款的内容，您务必在交付设备前登出您使用的账号。否则，由此产生的任何后果和损失均由您自行承担责任，鲨湾科技对此不承担任何责任。</p>
    <p>5. 蓝鲨电动使用当中的防丢报警提示，是为保护用户财产而设计，目的仅为警告或提醒，并无实际作用，车辆所有异常动态用户需要及时关注，用户同意并认可，用户并不依赖车辆报警提示对车辆防盗防抢所起作用。</p>
    <p>6. 用户应对“蓝鲨电动”及本服务中提供的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。蓝鲨电动不会对因用户行为而导致的任何损失或损害承担责任。如果用户发现任何人违反本《协议》约定或以其他不当的方式使用本服务，请立即向蓝鲨电动客服人员举报或投诉，蓝鲨电动将依本《协议》约定进行处理。</p>
    <p class="title">二、帐号注册及管理</p>
    <p>1. 蓝鲨电动的服务需要在注册账号后才能使用，请您按照页面提示完成账号注册程序。在注册账号前，您应阅读并接受《蓝鲨用户服务协议》和《蓝鲨隐私政策》。您一旦注册成功成为用户，您将得到一个帐号（或帐号及密码），此依赖于您注册成为用户的注册/登录方式。“蓝鲨电动”帐号应当成功添加蓝鲨电动车辆，您需要对自己在帐号中的所有活动和事件、行为负全责，包括用户所发布的任何内容以及由此产生的任何后果。蓝鲨电动可以根据用户需求或产品需要对帐号注册和绑定的方式进行变更，而且无须事先通知用户。</p>
    <p>2. 在注册成为用户后，您在蓝鲨电动应用内编辑个人信息，包括但不限于账户名称、昵称、密码、车辆名称等。蓝鲨电动对这些信息的使用将受第三条用户个人隐私信息保护的约束。</p>
    <p>3. “蓝鲨电动 ”帐号的所有权归鲨湾科技所有，用户完成申请注册手续后，获得“蓝鲨电动 ”帐号的使用权，该使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。</p>
    <p>4. 用户可以更改、删除“蓝鲨电动”帐户上的个人资料、注册信息及内容等，但需注意，删除有关信息的同时也会删除用户储存在系统中的相关数据，用户需承担该风险。</p>
    <p>5. 用户须对通过“蓝鲨电动”帐号或本服务发布信息的真实性、合法性、无害性、准确性、有效性等全权负责，与用户所传播的信息相关的任何法律责任由用户自行承担，与蓝鲨电动无关。如因此给蓝鲨电动或第三方造成损害的，用户应当依法承担相关经济及法律责任。</p>
    <p>6. 用户对密码加以妥善保管，切勿将密码告知他人，因密码保管不善而造成的所有损失由用户自行承担。如果发现您的账号存在未获授权的使用，或者其他可能危害您的账号安全的情形时，您应立即修改密码，并立即以有效方式通知鲨湾科技，要求鲨湾科技暂停相关服务。 您理解鲨湾科技对您的请求采取行动需要合理时间，对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担法律法规明确规定之外的责任。对于非因鲨湾科技的原因导致他人利用您的账号所进行的任何行为及因此而产生的后果或损失，请您向相应责任人索赔，鲨湾科技将提供必要的合理协助。</p>
    <p>7. 如果您遗失账号或遗忘密码，您应当按照蓝鲨电动提示的途径申请找回账号或修改密码。您应当妥善保管注册资料与密码保护资料，如果由于您提供的资料不真实、不完整、不准确、或由于蓝鲨以外的原因导致您的资料被他人知悉，您可能无法找回账号或修改密码。鲨湾科技通过识别您所提供资料与系统保存资料的一致性进行判断，不保证您一定可以通过前述方式找回账号或修改密码。</p>
    <p>8. 用户应遵守本《协议》的各项条款，正确、适当地使用本服务，如用户违反本《协议》中的任何条款，蓝鲨电动在通知用户后有权暂停或终止对违约用户的“蓝鲨电动”帐号提供服务。</p>
    <p>9. 用户不得利用“蓝鲨电动”帐号或本服务进行如下行为：</p>
    <p>(1) 提交、发布违法、虚假、损害他人权益的信息；</p>
    <p>(2) 盗用他人头像或资料，冒充、利用他人名义；</p>
    <p>(3) 利用技术手段入侵、篡改、盗用他人帐号；</p>
    <p>(4) 利用“蓝鲨电动 ”帐号或本服务从事任何违法犯罪活动；</p>
    <p>(5) 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否有商业目的；</p>
    <p>(6) 其他违反法律法规规定、侵犯其他用户合法权益、干扰“蓝鲨 APP”正常运营或蓝鲨电动未明示授权的行为。</p>
    <p>10. 发生如下任一情形时，蓝鲨电动有权回收用户的“蓝鲨电动 ”帐号，而无须承担任何责任：</p>
    <p>（1）用户注册帐号后，24小时内登录，45天未登录，帐号可能被收回。</p>
    <p>（2）系统检测帐号存在安全风险和违规操作，为保护帐号安全，蓝鲨电动会先进行冻结，用户未在30天内拨打客服电话确认身份解冻，帐号即被收回。</p>
    <p>（3）应法院、仲裁机构、行政执法部门的命令、要求收回帐号。</p>
    <p>（4）为维护公共利益需要收回帐号。</p>
    <p>11. 第三方产品和服务</p>
    <p>（1）您在使用本软件第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。我们和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</p>
    <p>（2）因用户使用本软件或要求我们提供特定服务时，本软件可能会调用第三方系统或者通过第三方支持用户的使用或访问，使用或访问的结果由该第三方提供，我们不保证通过第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此引发的任何争议及损害，我们不承担责任。</p>
    <p class="title">三、知识产权声明</p>
    <p>1. 蓝鲨电动提供的网络服务中包含的任何文本、图片、图形、音频和视频资料均受版权、商标或其他财产所有权法律的保护，未经相关权利人同意，上述资料均不得用于任何商业目的。</p>
    <p>2. 蓝鲨电动为提供网络服务而使用的任何软件（包括但不限于软件中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附加的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，用户不得对该软件进行反向工程（reverse engineer）、反向编译（decompile）会反汇编（disassemble）。</p>
    <p>3. 除本服务中所涉及广告的知识产权由相应广告主享有外，蓝鲨电动在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权均归蓝鲨电动所有，但用户在使用本服务前对自己发布的内容已合法取得知识产权的除外。</p>
    <p>4. 蓝鲨电动提供本服务时所依托软件的著作权、专利权及其他知识产权均归蓝鲨电动所有。</p>
    <p>5. 蓝鲨电动在本服务中所涉及的图形、文字或其组成，以及其他蓝鲨电动标志及产品、服务名称（以下统称“蓝鲨电动标识”），其著作权或商标权归蓝鲨电动所有。未经蓝鲨电动书面同意，用户不得将蓝鲨电动标识以任何方式展示或使用或用作其他用途，也不得向他人表明用户有权展示、使用、或处理蓝鲨电动标识的行为。</p>
    <p>6. 上述及其他任何蓝鲨电动或相关广告主依法拥有的知识产权均受到法律保护，未经蓝鲨电动或相关广告主书面许可，用户不得以任何形式进行使用或创造相关衍生作品。</p>
    <p>7. 若您认为蓝鲨电动的服务侵犯了您的合法权益，请您以书面的通讯方式向鲨湾科技提交权利通知及相关的支持性资料，鲨湾科技将会依照法律法规的要求进行处理。请您理解并同意，如果您提供的权利通知陈述失实，您将承担对由此造成的全部法律责任（包括但不限于赔偿各种费用及律师费）。</p>
    <p class="title">四、法律责任</p>
    <p>1. 如果蓝鲨电动发现或收到他人举报或投诉用户违反本《协议》约定的，蓝鲨电动有权不经通知随时对相关内容（包括但不限于用户资料、论坛文章）进行审查、删除，并视情节轻重对违规帐号进行处理，处理包括但不限于警告、帐号封禁。处理后蓝鲨电动会通知用户处理结果。</p>
    <p>2. 用户理解并同意，蓝鲨电动有权依合理判断对违反有关法律法规或本《协议》规定的行为进行处罚，对违法违规的用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应承担由此而产生的一切法律责任。</p>
    <p>3. 用户理解并同意，因用户违反本《协议》约定，导致或产生的任何第三方主张的索赔、要求或损失，包括合理的律师费等由违规用户承担。</p>
    <p class="title">五、不可抗力及其他免责事由</p>
    <p>1. 用户理解并确认，在使用本服务的过程中，可能会遇到不可抗力等风险因素使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害（如洪水、地震、瘟疫流行和风暴等）以及社会事件（如战争、动乱、政府行为等）以及黑客攻击、计算机病毒、网络故障。出现上述情况时，鲨湾科技将努力在第一时间与相关单位配合，及时进行修复，但是由此给用户或第三方造成的损失，蓝鲨电动及合作单位在法律允许的范围内免责。</p>
    <p>2. 本服务同大多数互联网服务一样，受包括但不限于用户原因、网络服务质量、社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他人利用用户的资料，造成现实生活中的骚扰；用户下载安装的其它软件或访问的其他APP中含有“特洛伊木马”等病毒，威胁到用户的手机信息和数据的安全，继而影响本服务的正常使用等等。用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭致损失和骚扰。</p>
    <p>3. 用户理解并确认，本服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险，因此导致的用户或第三方任何损失，蓝鲨电动不承担任何责任。</p>
    <p>4. 用户理解并确认，在使用本服务过程中存在来自任何他人的包括误导性的、欺骗性的、威胁性的、诽谤性的、令人反感的或非法的信息，或侵犯他人权利的匿名或冒名的信息，以及伴随该等信息的行为，因此导致的用户或第三方的任何损失，蓝鲨电动不承担任何责任。</p>
    <p>5. 用户理解并确认，蓝鲨电动需要定期或不定期地对“蓝鲨电动”平台或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，蓝鲨电动无需为此承担任何责任，但蓝鲨电动应事先进行通告。</p>
    <p>6. 蓝鲨电动依据法律法规、本《协议》约定获得处理违法违规或违约内容的权利，该权利不构成蓝鲨电动的义务或承诺，蓝鲨电动不能保证及时发现违法违规或违约行为或进行相应处理。</p>
    <p>7. 用户理解并确认，对于蓝鲨电动向用户提供的下列产品或者服务的质量缺陷及其引发的任何损失，蓝鲨电动无需承担任何责任：</p>
    <p>(1) 蓝鲨电动向用户免费提供的服务；</p>
    <p>(2) 蓝鲨电动向用户赠送的任何产品或者服务。</p>
    <p>8. 在任何情况下，蓝鲨电动均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害（包括因用户使用“蓝鲨电动 APP”或本服务而遭受的利润损失）承担责任，即使蓝鲨电动已被告知该等损失的可能性亦然。尽管本《协议》中可能含有相悖的规定，蓝鲨电动对用户承担的全部责任，无论因何原因或何种行为方式，始终不超过用户因使用蓝鲨电动提供的服务而支付给蓝鲨电动的费用。</p>
    <p class="title">六、服务的变更、中断、终止</p>
    <p>1. 鉴于网络服务的特殊性，用户同意蓝鲨电动有权根据业务发展情况随时变更、中断或终止部分或全部的服务（包括收费服务）而无需通知用户，也无需对任何用户或任何第三方承担任何责任。</p>
    <p>2. 如发生下列任何一种情形，蓝鲨电动有权变更、中断或终止向用户提供的免费服务或收费服务，而无需对用户或任何第三方承担任何责任：</p>
    <p>(1) 根据法律规定用户应提交真实信息，而用户提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；</p>
    <p>(2) 用户违反相关法律法规或本《协议》的约定；</p>
    <p>(3) 按照法律规定或有权机关的要求；</p>
    <p>(4) 出于安全的原因或其他必要的情形。</p>
    <p class="title">七、期限及终止</p>
    <p>1. 本用户服务条款的生效日期应为您同意本用户服务条款之日或使用蓝鲨电动服务之日中的较早日期，并且无固定的终止日期，除非根据以下情形而终止：</p>
    <p>(1) 您丧失民事权利能力或民事行为能力，或丧失其他主体的法律授权；</p>
    <p>(2) 鲨湾科技因为任何原因终止向您提供蓝鲨电动的服务；</p>
    <p>(3) 您主动地不再使用蓝鲨电动服务；</p>
    <p>(4) 其他导致本用户服务条款终止的原因。</p>
    <p>2. 本用户服务条款由于任何原因终止时，您将无法继续使用蓝鲨电动服务的任何部分，包括但不限于您的用户账号及用户内容。</p>
    <p>3. 您理解并同意，本用户服务条款终止后，蓝鲨电动将按照法律法规要求保存或删除您的个人信息等，具体处理方式可参考《蓝鲨隐私政策》。</p>
    <p>4. 在本用户服务条款终止后，鲨湾科技仍然可以依据相关法律法规及本用户服务条款向您追究违反法律法规或违反本用户服务条款行为的责任，本用户服务条款中关于个人信息保护、知识产权、担保与保证、责任承担、免责及责任限制、法律适用和争议解决的条款始终有效。</p>
    <p class="title">八、其他</p>
    <p>1. 鲨湾科技郑重提醒用户注意本《协议》中免除鲨湾科技责任和限制用户权利的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本《协议》。</p>
    <p>2. 本《协议》的效力、解释及纠纷的解决，适用于中华人民共和国法律。若用户和鲨湾科技之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户同意将纠纷或争议提交至上海市闵行区人民法院管辖。</p>
    <p>3. 如果本《协议》的任何约定与适用的法律法规冲突的，以适用的法律法规的规定为准。如本用户服务条款中的任何约定无论因何种原因无效或不可执行，其在不影响其他约定的情况下从本用户服务条款中被移除，各方应以具有相同效果的有效、可执行的且最能体现本用户服务条款内容和意图的条款（或部分）予以替换。本用户服务条款中的其余约定仍应保持有效并且具有完全的法律拘束力。</p>
    <p>4. 除非鲨湾科技以书面方式确认并同意，蓝鲨电动未履行本用户服务条款中任何权利或条款的行为不构成鲨湾科技对相关权利或条款的放弃。</p>
    <p>5. 本《协议》的所有标题仅为阅读方便，本身并无实际涵义，不得作为本用户服务条款涵义解释的依据。</p>
    <p>6. 本《协议》以中文书就。英文翻译版本（如有）仅为您的理解便利而提供，鲨湾科技和您之间的全部法律关系由本用户服务条款的中文版确定。如果中英文两个版本存在任何冲突之处，则以中文版本规定为准。</p>
    <p>7. 隐私政策</p>
    <p>(1) 请查阅我们的 《蓝鲨隐私政策》， 《蓝鲨隐私政策》为与本协议效力等同且不可分割的一部分。在任何时候，您的信息均依照 《蓝鲨隐私政策》处理。</p>
    <p>(2) 鲨湾科技将充分保护用户的个人隐私信息，保证不对外公开或向第三方透露用户个人隐私信息，或用户在使用服务时存储的非公开内容，除非根据法律或有法律赋予权限的政府部门要求或事先得到用户明确授权等原因，鲨湾科技需要披露用户的个人隐私信息，包括但不限于用户在使用蓝鲨电动服务过程中产生的骑行数据。</p>
    <p class="bottom">再次感谢您对蓝鲨电动的信任和使用！</p>
    <p class="name">鲨湾科技（上海）有限公司</p>
  </div>
</template>

<script>
export default {
  mounted(){
    document.title = "用户服务协议"
  }
}
</script>

<style lang="less" scoped>
.userwrapper{
  padding: 20px 15px;
  line-height: 20px;
  text-align: justify;
  font-size: 14px;
  color: #8c92a0;
  background-color: #111117;
  p{
    margin: 0;
    padding: 0;
  }
  .main{
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    margin-bottom: 10px;
    color: #fff;
  }
  .title{
    font-weight: bold;
    margin: 10px 0;
  }
  .bottom{
    margin-top: 20px;
  }
  .name{
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/userprotocol.vue